var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 7.27273C12.1164 7.27273 13.0837 6.29819 13.0837 5.09092C13.0837 3.88365 12.1164 2.9091 10.9091 2.9091C9.70185 2.9091 8.72731 3.88365 8.72731 5.09092C8.72731 6.29819 9.70185 7.27273 10.9091 7.27273ZM5.09096 7.27273C6.29823 7.27273 7.2655 6.29819 7.2655 5.09092C7.2655 3.88365 6.29823 2.9091 5.09096 2.9091C3.88369 2.9091 2.90914 3.88365 2.90914 5.09092C2.90914 6.29819 3.88369 7.27273 5.09096 7.27273ZM5.09096 8.72727C3.39642 8.72727 6.10352e-05 9.57818 6.10352e-05 11.2727V12C6.10352e-05 12.6025 0.488477 13.0909 1.09097 13.0909H9.09095C9.69344 13.0909 10.1819 12.6025 10.1819 12V11.2727C10.1819 9.57818 6.7855 8.72727 5.09096 8.72727ZM10.9091 8.72727C10.6982 8.72727 10.4582 8.74182 10.2037 8.76364C11.0473 9.37454 11.6364 10.1964 11.6364 11.2727V12C11.6364 12.6025 12.1248 13.0909 12.7273 13.0909H14.9091C15.5116 13.0909 16 12.6025 16 12V11.2727C16 9.57818 12.6037 8.72727 10.9091 8.72727Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/organisation.d83780d382ee762ea2b9f287fc2dcf9b.svg";
export { ForwardRef as ReactComponent };